import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { useSelector } from "react-redux";

// config
import { moderatorIconKeys } from "frontend/components/fort/mod/photos/config.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

const ImageStyled = styled.img`
    /* center absolutely positioned asset */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;

    /* resize asset so longest side spans parent container */
    max-height: 100%;
    max-width: 100%;

    background-color: ${colors.primary.whisker};

    ${({ imageIsBlurred }) => {
        if (imageIsBlurred) {
            return css`
                filter: blur(${convertPxToRem(15)});
            `;
        }
    }}
`;

// component
export const Image = ({ src, uploadId }) => {
    const uploadFooterActions =
        useSelector(state => state.uploadFooterActions.entities[uploadId]) ||
        {};
    const imageIsBlurred = uploadFooterActions[moderatorIconKeys.BLUR];
    return <ImageStyled src={src} imageIsBlurred={imageIsBlurred} />;
};

export default Image;

// prop-types
Image.propTypes = {
    src: PropTypes.string.isRequired,
    uploadId: PropTypes.string.isRequired
};
